module.exports = __webpack_public_path__ + "static/media/room-2.2aca3d1d.jpeg";